var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.546,
    height: 15.546,
    viewBox: "0 0 15.546 15.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M13.269,10.05A7.743,7.743,0,0,0,10.316,8.2a4.494,4.494,0,1,0-5.085,0A7.785,7.785,0,0,0,0,15.546H1.215a6.558,6.558,0,1,1,13.117,0h1.215A7.722,7.722,0,0,0,13.269,10.05Zm-5.5-2.277a3.279,3.279,0,1,1,3.279-3.279A3.283,3.283,0,0,1,7.773,7.773Z",
    transform: "translate(0)",
    fill: "#168794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.d98ca118f99750a8036709f8827e6ec0.svg";
export { ForwardRef as ReactComponent };